<template>
<default-layout section="holiday-landing-2008">
  <template slot-scope="slotProps">
  <div class="landing-container">
    <nav-spacer />
    <image-text-row :data="imageTextRow" />
  </div>
  </template>
</default-layout>
</template>


<script>
// Components
import DefaultLayout from '@/layouts/default';
import ImageTextRow from '@/modules/work/ImageTextRow';
import NavSpacer from '@/modules/header/NavSpacer';

export default {

  name: 'WorkMain',

  metaInfo: {
    title: 'Season\'s Greetings - Particle Design',
  },

  components: {
    DefaultLayout,
    ImageTextRow,
    NavSpacer,
  },

  data() {
    return {
      imageTextRow: {
        reversed: false,
        image: {
          src: "/static/content/uploads/Particle_2018HolidayEcard_LPcactus.gif",
          width: "regular",
          aspect: "medium",
          showResponsiveImage: false,
        },
        content: "# Thanks for making the world a brighter place!",
      },
    };
  },

};
</script>


<style lang="scss">
@import '../styles/_mixins.scss';
@import '../styles/_typography.scss';
@import '../styles/_mixins.scss';

.holiday-landing-2008 {

  /*
    this section handles "extended-desktop" mode
    it should be on all "core" pages
  */
  main {
    width: 100%;
    display: grid;

    // media query props
    grid-template-columns: 0 100vw 0;

    @include ngMq($layout--max-content-width, up) {
      grid-template-columns: 1fr $layout--max-content-width 1fr;
    }

    .landing-container {
      grid-column: 2 / span 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/HolidayLanding2008.vue